import React, { useState } from 'react';
import socketIOClient from 'socket.io-client';

const socket = socketIOClient('wss://mqtt-logger.cub.bi');

const MqttCommandSender = ({ topicPrefix, setTopic }) => {
    const [message, setMessage] = useState('');

    const sendCommand = () => {
        if (message.trim() === '') {
            alert('Message cannot be empty.');
            return;
        }

        const command = { topic: topicPrefix, message: message, TimeStamp: new Date().toISOString() };
        socket.emit('send_mqtt_command', command);
    };

    return (
        <div className="mqtt-command-sender">
            <h3>MQTT Command Sender</h3>
            <input
                type="text"
                placeholder="Enter Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
            />
            <button onClick={sendCommand}>Send</button>
        </div>
    );
};

export default MqttCommandSender;
